/**
 * Registro del módulo Análisis financiero.
 * Una sola entrada de menú. Las pestañas internas viven en la pantalla.
 */
import AnalisisFinancieroPage from "@/pages/analisis_financiero/AnalisisFinancieroPage";
import { buildModuloFromTabs, createModuloTab } from "@/modules/moduloTabRegistry";
import {
  ANALISIS_FINANCIERO_CONTEXT_LABEL,
  ANALISIS_FINANCIERO_PATH,
  MODULO_ANALISIS_FINANCIERO_CARD,
  MODULO_ANALISIS_FINANCIERO_ID,
  isAnalisisFinancieroPath,
} from "@/modules/analisis_financiero/manifest";

const TABS = [
  createModuloTab({
    path: ANALISIS_FINANCIERO_PATH,
    label: "Análisis financiero",
    description: "Gastos razonables y proyectado al cierre.",
    iconKey: "chart",
    navSection: "Análisis",
    testid: "nav-analisis-financiero",
    component: <AnalisisFinancieroPage />,
  }),
];

export const MODULO_ANALISIS_FINANCIERO = buildModuloFromTabs({
  id: MODULO_ANALISIS_FINANCIERO_ID,
  card: MODULO_ANALISIS_FINANCIERO_CARD,
  contextLabel: ANALISIS_FINANCIERO_CONTEXT_LABEL,
  tabs: TABS,
});

export { isAnalisisFinancieroPath };
export const getModuloAnalisisFinancieroRoutes = () => MODULO_ANALISIS_FINANCIERO.getRoutes();
